// v-for in slot might cause error.
<template lang="pug">
div.lower-subpanel-wrap
  slot(name="button-1")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-2")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-3")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-4")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-5")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-6")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-7")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-8")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap
  slot(name="button-9")
    div.btn.control-button.control-button-red.button-transparent
      div.button-inside-wrap

</template>

<script>
export default {
  name: 'BottomButtons',
};
</script>

<style lang="sass">
.button-transparent
  background-color: transparent;
  box-shadow: none;
  pointer-events: none
</style>





// WEBPACK FOOTER //
// BottomButtons.vue?7534297f